/* unplugin-vue-components disabled */import { render } from "./FormArea.vue?vue&type=template&id=11f0b5cf&ts=true"
import script from "./FormArea.vue?vue&type=script&lang=ts"
export * from "./FormArea.vue?vue&type=script&lang=ts"

import "./FormArea.vue?vue&type=style&index=0&id=11f0b5cf&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__